import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Popup from "ui/Popup/Popup";
import calcul_pandi, {
  calcul_assurance,
  calcul_interets,
  courbes,
} from "utils/CreditImmobilier/calcul_mensualite";
import Info from "../../../../../components/v3/Estimation/icons/Info";
import {
  actions as MensualActions,
  selectors as MensualSelectors,
} from "../../../../../redux/slices/v2/CaclulezMensualite";
import CustomInput from "../../../../../ui/CustomInput/Input";
import CustomSelect from "../../../../../ui/CustomSelect/CustomSelect";
import style from "./RevenuMensuel.module.css";

function RevenuMensuel({ t }: { t: any }) {
  let insurance_rate = 0.297 / 100;
  let tva_rate = 10;

  const prixDeBienSelector = useSelector(MensualSelectors.mensualPrixDeBien);

  const acompteSelector = useSelector(MensualSelectors.mensualAcompte);

  const programeSelector = useSelector(MensualSelectors.mensualProgramme);

  const tauxSelector = useSelector(MensualSelectors.mensualTaux);

  const dispatch = useDispatch();

  const [revenuData, setRevenuData] = useState({
    PrixDeBien: prixDeBienSelector,
    Acompte: {
      prix: acompteSelector.prix,
      percent: acompteSelector.percent,
    },
    Taux: tauxSelector,
    Programme: programeSelector,
  });

  const programeDePret = [t("15 ans"), t("20 ans"), t("25 ans")];
  const programeDePret_duree = {
    "15 ans": 180,
    "20 ans": 240,
    "25 ans": 300,
  };
  useEffect(() => {
    dispatch(MensualActions.setPrixDeBien(revenuData.PrixDeBien));
    dispatch(
      MensualActions.setAcompte({
        ...revenuData.Acompte,
      })
    );
    dispatch(MensualActions.setPrograme(revenuData.Programme));
    dispatch(MensualActions.setTaux(revenuData.Taux));

    let interets = calcul_interets(
      revenuData.PrixDeBien,
      parseInt(revenuData.Acompte.prix.toString().replace(" ", "")),
      revenuData.Taux,
      programeDePret_duree[revenuData.Programme],
      1
    );
    let tva_sur_interets = (interets * tva_rate) / 100;
    let assurances = calcul_assurance(
      revenuData.PrixDeBien,
      parseInt(revenuData.Acompte.prix.toString().replace(" ", "")),
      insurance_rate * 100,
      programeDePret_duree[revenuData.Programme],
      1
    );
    let pandi = calcul_pandi(
      revenuData.PrixDeBien,
      parseInt(revenuData.Acompte.prix.toString().replace(" ", "")),
      revenuData.Taux,
      programeDePret_duree[revenuData.Programme]
    );
    let mensualite =
      calcul_pandi(
        revenuData.PrixDeBien,
        parseInt(revenuData.Acompte.prix.toString().replace(" ", "")),
        revenuData.Taux + insurance_rate * 100,
        programeDePret_duree[revenuData.Programme]
      ) + tva_sur_interets;
    // let mensualite = pandi + tva_sur_interets + assurances;
    let all_courbes = courbes(
      revenuData.PrixDeBien,
      parseInt(revenuData.Acompte.prix.toString().replace(" ", "")),
      revenuData.Taux,
      insurance_rate * 100,
      programeDePret_duree[revenuData.Programme]
    );

    dispatch(MensualActions.setPANDI(Math.max(parseInt(pandi.toString()), 0)));
    dispatch(
      MensualActions.setTaxes(
        Math.max(parseInt(tva_sur_interets.toString()), 0)
      )
    );
    dispatch(
      MensualActions.setAssurances(Math.max(parseInt(assurances.toString()), 0))
    );
    dispatch(
      MensualActions.setMensualite(Math.max(parseInt(mensualite.toString()), 0))
    );
    dispatch(MensualActions.setCapital_restant(all_courbes.capital_restant));
    dispatch(MensualActions.setinterets_cumules(all_courbes.interets_cumules));
    dispatch(
      MensualActions.setprincipal_rembourse(all_courbes.principal_rembourse)
    );
  }, [revenuData]);

  const [popedUp, setPopedUp] = useState(false);

  const popupText = `
                        ${t("La calculatrice hypothécaire")}`;

  return (
    <div className={style.container}>
      <div className={style.formContainer}>
        <div className={style.Revenu}>
          <label htmlFor="prixDeBien">{t("Prix du bien")}</label>
          <div className={style.formInput}>
            <CustomInput
              type={"string"}
              name={"prixDeBien"}
              id={"prixDeBien"}
              pattern="\d*"
              min={0}
              value={
                revenuData.PrixDeBien
                  ? revenuData.PrixDeBien.toString().replace(
                      /(.)(?=(\d{3})+$)/g,
                      "$1 "
                    )
                  : ""
              }
              styleInput={style.custumInput}
              styleLabel={style.Label}
              styleInputFor={style.mad}
              styleContainer={style.inputContainer}
              onChange={(e) => {
                setRevenuData({
                  ...revenuData,
                  PrixDeBien: parseInt(e.target.value.replaceAll(" ", "")),
                });
              }}
              inputFor={t("MAD")}
              placeHolder={t("Ex 800 000")}
            />
          </div>
        </div>
        <div className={style.Revenu}>
          <label htmlFor="Acompte">{t("Acompte")}</label>
          <div className={style.RevenuAcompte}>
            <div className={style.formInput}>
              <CustomInput
                type={"string"}
                id={"Acompte"}
                name={"Acompte"}
                pattern="\d*"
                min={0}
                value={
                  revenuData.Acompte.prix
                    ? revenuData.Acompte.prix
                        .toString()
                        .replace(/(.)(?=(\d{3})+$)/g, "$1 ")
                    : ""
                }
                styleInput={style.custumInput}
                styleLabel={style.Label}
                styleContainer={style.inputContainer}
                onChange={(e) => {
                  setRevenuData({
                    ...revenuData,
                    Acompte: {
                      ...revenuData.Acompte,
                      prix: parseInt(e.target.value.replaceAll(" ", "")),
                      percent: revenuData.PrixDeBien
                        ? parseInt(
                            (
                              (parseInt(e.target.value.replaceAll(" ", "")) *
                                100) /
                              revenuData.PrixDeBien
                            ).toString()
                          )
                        : "",
                    },
                  });
                }}
                inputFor={t("MAD")}
                styleInputFor={style.mad}
                placeHolder={t("Ex 100 000")}
              />
            </div>
            <div className={style.formInput}>
              <CustomInput
                type={"string"}
                id={"AcomptePercent"}
                name={"AcomptePercent"}
                pattern="\d*"
                min={0}
                value={
                  revenuData.Acompte.percent ? revenuData.Acompte.percent : 0
                }
                styleInput={style.custumInput}
                styleLabel={style.Label}
                styleContainer={style.inputContainer}
                onChange={(e) => {
                  setRevenuData({
                    ...revenuData,
                    Acompte: {
                      // ...revenuData.Acompte,
                      percent: Math.min(
                        parseInt(e.target.value.replaceAll(" ", "")),
                        100
                      ),
                      prix: revenuData.PrixDeBien
                        ? parseInt(
                            (
                              (parseInt(revenuData.PrixDeBien.toString()) *
                                Math.min(
                                  parseInt(e.target.value.replaceAll(" ", "")),
                                  100
                                )) /
                              100
                            ).toString()
                          )
                        : 0,
                    },
                  });
                }}
                inputFor={"%"}
                styleInputFor={style.percent}
                placeHolder={"%"}
              />
            </div>
          </div>
        </div>
        <div className={style.Revenu}>
          <div className={style.formInputAvance}>
            <label htmlFor="programeDePret">{t("Programme de prêt")}</label>
            <div className={style.formInput}>
              <CustomSelect
                name={"programeDePret"}
                id={"programeDePret"}
                styleSelect={style.custumSelect}
                styleLabel={style.Label}
                styleContainer={style.inputContainer}
                onChange={(e) => {
                  setRevenuData({
                    ...revenuData,
                    Programme: e.target.value,
                  });
                }}
                defaultValue={revenuData.Programme}
                optionsArray={programeDePret}
              />
            </div>
          </div>
          <div className={style.formInputAvance}>
            <label htmlFor="Taux">{t("Taux d'intérêt")}</label>
            <div className={style.formInput}>
              <CustomInput
                type={"number"}
                id={"Taux"}
                pattern="\d*"
                value={revenuData.Taux ? revenuData.Taux : ""}
                styleInput={style.custumInput}
                styleLabel={style.Label}
                styleContainer={style.inputContainer}
                onChange={(e) => {
                  setRevenuData({
                    ...revenuData,
                    Taux: parseFloat(e.target.value),
                  });
                }}
                placeHolder={t("Taux d'intérêt")}
                inputFor={"%"}
                styleInputFor={style.percent}
              />
            </div>
          </div>
        </div>
        <div>
          <p className={style.infos}>
            {t("Limitation de responsabilité")}
            <span
              style={{ position: "relative", width: "5px", height: "20px" }}
              onMouseEnter={() => {
                setPopedUp(true);
              }}
              onMouseLeave={() => {
                setPopedUp(false);
              }}
            >
              <Info opacity={true} />
              {popedUp ? (
                <Popup
                  title={t("Limitation de responsabilité")}
                  text={popupText}
                />
              ) : null}
            </span>
          </p>
        </div>
      </div>
    </div>
  );
}

export default RevenuMensuel;
